<template>
  <div>
    <component :is="component"></component>
  </div>
</template>

<script>
import PaymentSetups from './Main';
import PaymentSetupsForm from './Form';

export default {
  name: 'PaymentSetupsMain',

  data() {
    return {
      component: null,
    };
  },

  components: {
    PaymentSetups,
    PaymentSetupsForm,
  },

  methods: {
    checkPage(to) {
      if (to.params.page === 'edit' || to.params.page === 'create') {
        this.component = PaymentSetupsForm;
      } else {
        this.component = PaymentSetups;
      }
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.checkPage(to);
    next();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.checkPage(to);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/setups/Index.vue